export default {
  PAGE_SIZE: 20,
  PAGE_SIZE_OPTIONS: ['10', '20', '50', '100'],
  PAGE_SIZE_LARGE: 100,
  PAGE_SIZE_OPTIONS_LARGE: ['100', '200', '300', '500', '1000'],
};
